var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIconCrossed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-send_icon_crossed"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send_icon_crossed",
    "data-name": "Artboard \\u2013 15",
    clipPath: "url(#clip-send_icon_crossed)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Buttons_Social_Facebook_Square_Hover",
    "data-name": "Buttons/Social/Facebook/Square/Hover",
    transform: "translate(0.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons_Social_Facebook_Square_Hover-2",
    "data-name": "Buttons/Social/Facebook/Square/Hover",
    transform: "translate(-7.029 -5.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_16px_info_send_",
    "data-name": "Icons/16px/info/send ",
    transform: "translate(7.029 7.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M12,0,0,9.6v5.6l2.88-3.44",
    transform: "translate(4)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M0,6.4,16,0,12.8,16Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M531.411,38.237,549.1,20.548",
    transform: "translate(45.411 -525.509) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconCrossed);
export default __webpack_public_path__ + "static/media/send_icon_crossed.a921abc1df96a5e542d55875a1ea9779.svg";
export { ForwardRef as ReactComponent };